<!-- response-graphs.component.html -->
<div *ngIf="data" class="graph-container">
	<div class="graph">
		<div class="label">Video</div>
		<div class="bar-container">
			<div class="bar video-bar" [style.left]="calcPercentage(data.video.min, data.video.max + 10)" [style.width]="calcPercentage(data.video.max - data.video.min, data.video.max + 10)"></div>
			<div class="marker" [style.left]="calcPercentage(data.video.average, data.video.max + 10)" style="border-left: 2px solid black">{{ data.video.average.toFixed(0) }} Sec</div>
		</div>
		<div class="range">
			<span>0</span>
			<span>{{ data.video.max + 10 }}</span>
		</div>
	</div>

	<div class="graph">
		<div class="label">Audio</div>
		<div class="bar-container">
			<div class="bar audio-bar" [style.left]="calcPercentage(data.audio.min, data.audio.max + 10)" [style.width]="calcPercentage(data.audio.max - data.audio.min, data.audio.max + 10)"></div>
			<div class="marker" [style.left]="calcPercentage(data.audio.average, data.audio.max + 10)" style="border-left: 2px solid black">{{ data.audio.average.toFixed(0) }} Sec</div>
		</div>
		<div class="range">
			<span>0</span>
			<span>{{ data.audio.max }}</span>
		</div>
	</div>

	<div class="graph">
		<div class="label">Text</div>
		<div class="bar-container">
			<div class="bar text-bar" [style.left]="calcPercentage(data.text.min, data.text.max + 10)" [style.width]="calcPercentage(data.text.max - data.text.min, data.text.max + 10)"></div>
			<div class="marker" [style.left]="calcPercentage(data.text.average, data.text.max + 10)" style="border-left: 2px solid black">{{ data.text.average.toFixed(0) }} Words</div>
		</div>
		<div class="range">
			<span>0</span>
			<span>{{ data.text.max }}</span>
		</div>
	</div>
</div>
